export default __webpack_public_path__ + "KaTeX_Caligraphic-Regular.4519ba4c9ee4f9b689505e396b96d93c.woff2";